/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Send_MessagesInputs */



/**
* | output |
* | --- |
* | "Send Messages and Create Posts" |
*
* @param {Leveling_Perm_Send_MessagesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_send_messages = /** @type {((inputs?: Leveling_Perm_Send_MessagesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Send_MessagesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправлять сообщения и создавать публикации")
	return /** @type {LocalizedString} */ ("Send Messages and Create Posts")
});